import React, { useState } from "react";
import PropTypes from "prop-types";

import IconButton from "@material-ui/core/IconButton";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export const handleMenu = (event, setAnchorEl) => {
  setAnchorEl(event.currentTarget);
};

export const handleClose = setAnchorEl => {
  setAnchorEl(null);
};

const Usermenu = ({ entries, settingDefaultKeepMounted }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <div>
      <IconButton
        aria-label="Account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={event => handleMenu(event, setAnchorEl)}
        color="inherit"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted={settingDefaultKeepMounted}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={open}
        onClose={() => handleClose(setAnchorEl)}
      >
        {entries.map(entrie => (
          <MenuItem
            key={entrie.title}
            onClick={() => {
              handleClose(setAnchorEl);
              entrie.func();
            }}
          >
            {entrie.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

Usermenu.defaultProps = {
  settingDefaultKeepMounted: true,
};

Usermenu.propTypes = {
  entries: PropTypes.array.isRequired,
  settingDefaultKeepMounted: PropTypes.bool,
};

export default Usermenu;
